export const getExternalLinkHref = (link: string) => {
  if (!link.includes('//')) {
    return '//' + link;
  }

  return link;
};